import { createSlice } from '@reduxjs/toolkit'
import { CustomEventState } from '../types/customEvent.types'

const initialState: CustomEventState = {
  interactionStatusEvent: 0,
}

const customEventSlice = createSlice({
  name: 'customEvent',
  initialState,
  reducers: {
    triggerInteractionStatusEvent: (state) => {
      state.interactionStatusEvent += 1
    },
  },
})

export const { triggerInteractionStatusEvent } = customEventSlice.actions
export default customEventSlice.reducer
